var exports = {
  "kL": "VideoPlayer.module__container___N0g4bj",
  "Ki": "VideoPlayer.module__video___N0g4bj",
  "ER": "VideoPlayer.module__videoHidden___N0g4bj",
  "mz": "VideoPlayer.module__seekPreviewVideo___N0g4bj",
  "IN": "VideoPlayer.module__posterOverlay___N0g4bj",
  "lW": "VideoPlayer.module__posterImage___N0g4bj",
  "aO": "VideoPlayer.module__thumbHashPlaceholder___N0g4bj",
  "HT": "VideoPlayer.module__playOverlayButton___N0g4bj",
  "$Z": "VideoPlayer.module__controlsOverlay___N0g4bj",
  "hr": "VideoPlayer.module__progressBar___N0g4bj",
  "xu": "VideoPlayer.module__controlsRow___N0g4bj",
  "it": "VideoPlayer.module__controlsLeft___N0g4bj",
  "QE": "VideoPlayer.module__controlsCenter___N0g4bj",
  "BT": "VideoPlayer.module__controlsRight___N0g4bj",
  "sL": "VideoPlayer.module__playPauseIndicator___N0g4bj",
  "HA": "VideoPlayer.module__fillContainer___N0g4bj",
  "Y5": "VideoPlayer.module__fullscreen___N0g4bj",
};

module.exports = exports;
